import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'shared-form-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-header.component.html',
  styleUrl: './form-header.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormHeaderComponent {
  formTitle: InputSignal<string> = input.required();
}
